/** Texto derecho del bloque Summary en Packing List (PDF/Excel). */

export const PACKING_LIST_TEXTO_ADICIONAL_MAX = 400;

function safe(v) {
  return v == null ? '' : String(v);
}

export function truncateTextoAdicionalPackingList(value) {
  return String(value ?? '').slice(0, PACKING_LIST_TEXTO_ADICIONAL_MAX);
}

export function textoAdicionalPackingListFromCliente(cliente) {
  if (!cliente) return '';
  return truncateTextoAdicionalPackingList(cliente.texto_adicional_packing_list);
}

function normalizeCountryForPackingList(s) {
  const t = safe(s).trim();
  if (!t) return '';
  return /^brasil$/i.test(t) ? 'Brazil' : t;
}

function normalizePortLabelForPackingList(label) {
  const t = safe(label).trim();
  if (!t) return '';
  return t.replace(/\((\s*Brasil\s*)\)/i, '(Brazil)');
}

export function formatHsSummaryLine(hs) {
  const s = safe(hs).replace(/\s/g, '');
  if (!s) return '';
  if (/^\d{8}$/.test(s)) return `${s.slice(0, 4)} ${s.slice(4, 6)} ${s.slice(6, 8)}`;
  return safe(hs).trim();
}

export function productsCellFromPackingRow(r) {
  const t = safe(r?.productos_texto);
  if (t) return t;
  return [safe(r?.grado_celda), safe(r?.proveedor_celda), safe(r?.almacen_celda)]
    .filter(Boolean)
    .join(' / ');
}

/**
 * Texto por defecto del Summary (4 líneas) cuando el cliente no tiene plantilla.
 */
export function buildDefaultPackingListSummaryText({
  productDescription = '',
  paisOrigen = '',
  hsCode = '',
  lugarEntrega = '',
  nombrePuertoDestino = '',
  paisDestino = '',
  detalleExcel = [],
}) {
  const desc =
    safe(productDescription).trim() ||
    productsCellFromPackingRow((detalleExcel || [])[0] || {});
  const line1 = desc.trim().replace(/\s+/g, ' ').toUpperCase();
  const entrega = lugarEntrega && String(lugarEntrega).trim();
  const line2 = entrega
    ? entrega.toUpperCase()
    : [
        normalizePortLabelForPackingList(nombrePuertoDestino),
        normalizeCountryForPackingList(paisDestino),
      ]
        .filter(Boolean)
        .join(', ')
        .toUpperCase();
  const country = normalizeCountryForPackingList(paisOrigen).toUpperCase();
  const hs = formatHsSummaryLine(hsCode);
  const line3 = country ? `COUNTRY OF ORIGIN: ${country}` : '';
  const line4 = hs ? `HS CODE ${hs.toUpperCase()}` : '';
  return truncateTextoAdicionalPackingList(
    [line1, line2, line3, line4].filter(Boolean).join('\n')
  );
}

/** Texto guardado en el PL o, si vacío, el bloque calculado (compat. registros antiguos). */
export function resolvePackingListSummaryText(params = {}) {
  const custom = truncateTextoAdicionalPackingList(params.summaryAdditionalText).trim();
  if (custom) return custom;
  return buildDefaultPackingListSummaryText(params);
}
